import TabsElement from './TabsElement';
import TabsElementDefinition from './TabsElementDefinition';
import TabsElementMetaData from './TabsElementMetaData';

export default {
  TabsElement: TabsElement,
  TabsElementDefinition: TabsElementDefinition,
  TabsElementType: TabsElementMetaData.type,
};
